import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { usePostMasters } from '../../../api/masters/masters';
import { ErrorInfo, MastersSearchConditions } from '../../../api/model';
import { useDefaultOptions } from '../../../hooks/api';
import { MasterList } from './MasterList';
import { MasterSearch } from './MasterSearch';

/**
 * タブタイトル
 * @returns
 */
function Title() {
  // 言語情報
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t('CMS-POC|マスタ一覧')}</title>
    </Helmet>
  );
}

function MastersListPage() {
  const {
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);
  const [params] = useSearchParams();
  const [conditions, setCondition] = useState<MastersSearchConditions>({});
  const { data, mutateAsync } = usePostMasters<AxiosError<ErrorInfo>, unknown>(options);

  useEffect(() => {
    const searchCondition: MastersSearchConditions = {};

    searchCondition.is_master = Number(params.get('is_master')) || undefined;
    searchCondition.master_name = params.get('master_name') || '';
    searchCondition.latest = Number(params.get('latest')) || undefined;

    setCondition(searchCondition);
  }, [params]);

  // 一覧表示
  useEffect(() => {
    const postMasters = async () => {
      await mutateAsync({ data: conditions });
    };
    void postMasters();
  }, [conditions, mutateAsync]);

  return (
    <div id="main">
      <Title />
      <section>
        <MasterSearch />
        <MasterList masters={data?.data.masters || []} conditions={conditions}/>
      </section>
    </div>
  );
}

export default MastersListPage;
